import { IModel, IResourceContext } from '../base/annotation';
import { IDataFlowDSLModelAdapter } from './dataflow.dsl-model-adapter';
import { IDSLAdaptation, DataFlowDSLAdapterRegistry } from './dataflow.dsl-adapter-registry';

export class DataFlowDSLAdapterContext {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private readonly modelToAdapters = new Map<IModel, IDataFlowDSLModelAdapter<any>>();

    constructor(public readonly contextData: IResourceContext) {}

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public adapterFor(model: IModel): IDataFlowDSLModelAdapter<any> | undefined {
        const adapter = this.modelToAdapters.get(model);
        if (adapter) {
            return adapter;
        }
        this.createAdapter(model);
        return this.modelToAdapters.get(model);
    }

    private matchingAdaptation(model: IModel): IDSLAdaptation | undefined {
        // Look at the spec and pick the right adapter to create. There can only be one
        const adaptations = DataFlowDSLAdapterRegistry.adaptations(model);

        if (!adaptations) {
            return undefined;
        }

        return adaptations[0];
    }

    private createAdapter(model: IModel): void {
        const matchAdaptation = this.matchingAdaptation(model);
        if (!matchAdaptation) {
            return;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const adapter = new (matchAdaptation.adapterConstructor as any)() as IDataFlowDSLModelAdapter<any>;
        adapter.initContext(this);

        this.modelToAdapters.set(model, adapter);
    }
}
